import Promise$1 from 'bluebird';
import { CustomsInvoiceMapper } from './CustomsInvoiceMapper.js';
import { CustomsUserInformationMapper } from './CustomsUserInformation/CustomsUserInformationMapper.js';

class CustomsInvoicesRepository {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  get(id) {
    return this.apiClient.get(`v1/customs-invoices/${id}`).then(response => CustomsInvoiceMapper.createModelFromResponse(response.data));
  }
  create(invoice) {
    return this.apiClient.post('v1/customs-invoices', CustomsInvoiceMapper.createApiPayload(invoice)).then(response => CustomsInvoiceMapper.createModelFromResponse(response.data));
  }
  update(invoice) {
    return this.apiClient.put(`v1/customs-invoices/${invoice.id}`, CustomsInvoiceMapper.createApiPayload(invoice)).then(response => CustomsInvoiceMapper.createModelFromResponse(response.data));
  }
  getDocumentUrl(id) {
    return this.apiClient.get(`v1/customs-invoices/${id}/download`).then(response => response.data);
  }
  getSenderData() {
    return this.apiClient.get('/v1/customs-sender-data').then(response => CustomsUserInformationMapper.createModelFromResponse(response.data)).catch(error => {
      if (error.status === 404) {
        // There is no saved data for this user
        return undefined;
      }
      return Promise$1.reject(error);
    });
  }
}

export { CustomsInvoicesRepository };
//# sourceMappingURL=CustomsInvoicesRepository.js.map
